import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default (props)=> <SvgIcon {...props} >
    <path d="M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z" />
    <text x="8" y="16" className="small" style={{   fontSize: "7px", fontWeight: "300"}}>15</text>
  </SvgIcon>